import { useDesignMaxTheme } from "@/packages";
import { Center, chakra } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { type TextBannerProps } from "./textBanner.type";

export const TextBanner = ({ inView, children }: TextBannerProps) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isLaptop, isMobile } = MEDIAS();
    const maxWidth = isLaptop ? "720px" : "896px";
    const height = isLaptop ? "360px" : "464px";

    return (
        <Center maxW={isMobile ? "none" : maxWidth} w="100%">
            <Center
                w="100%"
                height={isMobile ? "100%" : height}
                paddingX="24px"
                paddingY={isMobile ? "48px" : "10px"}
                rowGap="10px"
                flexDir="column"
                borderRadius="16px"
                background="whiteAlpha.900"
            >
                <MotionCenter
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexDir="column"
                    rowGap="24px"
                    initial={{ opacity: 0 }}
                    animate={inView ? { opacity: 1, transition: { duration: 1.5 } } : {}}
                >
                    {children}
                </MotionCenter>
            </Center>
        </Center>
    );
};

const MotionCenter = chakra(motion.div);
